export default "__VITE_ASSET__BS4wfBe7__"